import { render, staticRenderFns } from "./select-simple.vue?vue&type=template&id=89f16f38&"
import script from "./select-simple.vue?vue&type=script&lang=js&"
export * from "./select-simple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports